export default __webpack_public_path__ + "static/media/new_tutorial_privilege_coupons_1x.f5308e37.webp";